// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2xvxW","checkboxCol":"Table_checkboxCol__2Rz2b","emailCol":"Table_emailCol__rOQ3O","actionCol":"Table_actionCol__2J85q"};